// import Vue from "vue";
// import VueRouter from "vue-router";
import { createRouter, createWebHistory } from 'vue-router'
import WelcomeToFDX from "../components/WelcomeToFDX.vue";
import WelcomeToFdxAPI from "../components/WelcomeToFdxAPI.vue";
import Welcome from "../components/Welcome.vue";
import EmailVerification from "../components/EmailVerification.vue";
import WelcomeReview from "../components/WelcomeReview.vue";
import StartPage from "../views/StartPage.vue";
import AccountViewOrganization from "../views/AccountViewOrganization.vue";
import AccountView from "../views/AccountView.vue";
import ThankyouView from "../views/ThankyouView.vue";
import DocusignAuth from "../views/DocusignAuth.vue";
import SSO from "../views/SSO.vue";
import AuthUser from "../views/AuthUser.vue";
import Signout from "../views/Signout.vue";
import AdminDashboard from "../views/AdminDashboard.vue";
import CheckList from "../views/CheckList.vue";
import ErrPage from "../views/ErrPage.vue";
import EmailSent from "../views/EmailSent.vue";


// Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Get Started",
    props: true,
    component: StartPage,
    breadcrumb: "Get Started"
  },
  {
    path: "/organizationaccount",
    name: "AccountViewOrganization",
    props: true,
    component: AccountViewOrganization,
  },
  {
    path: "/accountview",
    name: "AccountView",
    props: true,
    component: AccountView,
  },
  {
    path: "/thankyou",
    name: "thankyou",
    component: ThankyouView,
  },
  {
    path: "/welcometofdx",
    name: "WelcomeToFDX",
    component: WelcomeToFDX,
  },
  {
    path: "/welcometofdxapi",
    name: "WelcomeToFdxAPI",
    component: WelcomeToFdxAPI,
  },
  {
    path: "/welcome",
    name: "Welcome",
    component: Welcome,
  },
  {
    path: "/welcomereview",
    name: "WelcomeReview",
    component: WelcomeReview,
  },
  {
    path: "/emailVerification",
    name: "EmailVerification",
    props: true,
    component: EmailVerification,
  },
  {
    path: "/authDocusign",
    name: "DocusignAuth",
    component: DocusignAuth,
  },
  {
    path: "/login",
    name: "SSO",
    breadcrumb: "SSO Authentication",
    component: SSO,
  },
  {
    path: "/auth",
    name: "AuthUser",
    props: true,
    breadcrumb: "Authentication",
    component: AuthUser,
  },
  {
    path: "/logout",
    name: "Signout",
    breadcrumb: "Signout",
    component: Signout,
  },
  {
    path: "/admindashboard",
    name: "AdminDashboard",
    component: AdminDashboard,
  },
  {
    path: "/checklist",
    name: "CheckList",
    component: CheckList,
  },
  {
    path: "/errpage",
    name: "ErrPage",
    component: ErrPage,
  },
  {
    path: "/emailSent",
    name: "EmailSent",
    props: true,
    component: EmailSent,
  }
];

const router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
      document.getElementById('app').scrollIntoView({ behavior: 'smooth' });
  }
});

export default router;
